import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { pagePermissionGuard } from './core/guard/page-permission.guard';
import { ErrorComponent } from './shared/organisms/error/error.component';
import { ERROR_MESSAGES } from './core/constants/error-messages.constants';
import { AuthGuard } from '@auth0/auth0-angular';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./modules/login/login.module').then(m => m.LoginModule)
  },
  {
    path: 'home',
    loadChildren: () => import('./modules/home/home.module').then(m => m.HomeModule),
    canActivate: [AuthGuard, pagePermissionGuard]
  },
  {
    path: 'list-users',
    loadChildren: () => import('./modules/users/list-users/list-users.module').then(m => m.ListUsersModule),
    canActivate: [AuthGuard, pagePermissionGuard]
  },
  {
    path: 'list-economic-group',
    loadChildren: () => import('./modules/licensed/list-economic-group/list-economic-group.module').then(m => m.ListEconomicGroupModule),
    canActivate: [AuthGuard, pagePermissionGuard]
  },
  {
    path: 'pharmaceutical-market-analysis',
    loadChildren: () => import('./modules/licensed/pharmaceutical-market-analysis/pharmaceutical-market-analysis.module').then(m => m.PharmaceuticalMarketAnalysisModule),
    canActivate: [AuthGuard, pagePermissionGuard]
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./modules/dashboards/dashboards.module').then(m => m.DashboardsModule),
    canActivate: [AuthGuard, pagePermissionGuard]
  },
  {
    path: 'product',
    loadChildren: () => import('./modules/products/products.module').then(m => m.ProductsModule),
    canActivate: [AuthGuard, pagePermissionGuard]
  },
  {
    path: 'cadastro',
    loadChildren: () => import('./modules/registers/registers.module').then(m => m.RegistersModule),
    canActivate: [AuthGuard, pagePermissionGuard]
  },
  {
    path: 'score',
    loadChildren: () => import('./modules/licensed/score/score.module').then(m => m.ScoreModule),
    canActivate: [AuthGuard, pagePermissionGuard]
  },
  {
    path: 'list-contracts',
    loadChildren: () => import('./modules/licensed/list-contracts/list-contracts.module').then(m => m.ListContractsModule),
    canActivate: [AuthGuard, pagePermissionGuard]
  },
  {
    path: 'ativar-precificacao',
    canActivate: [AuthGuard],
    loadChildren: () => import('./modules/licensed/client-activation/client-activation.module').then(m => m.ClientActivationModule)
  },
  {
    path: 'unauthorized',
    component: ErrorComponent,
    data: {
      code: 403,
      message: ERROR_MESSAGES[403]
    }
  },
  {
    path: 'gerencia-credenciais',
    loadChildren: () => import('./modules/credential-manager/credential-manager.module').then(m => m.CredentialManagerModule),
    canActivate: [AuthGuard, pagePermissionGuard]
  },
  {
    path: 'gerador-url',
    loadChildren: () => import('./modules/url-generator/url-generator.module').then(m => m.UrlGeneratorModule),
    canActivate: [AuthGuard, pagePermissionGuard]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
